import React, { useState } from 'react';
import '../styles/SignUpExample.css';

const LAST_NAME_INPUT_ID_SUFFIX = '-last-name';

const createLastNameInputId = () => {
  const dynamicPrefix = Math.random().toString(36).slice(2, 10);
  return `${dynamicPrefix}${LAST_NAME_INPUT_ID_SUFFIX}`;
};

const createEmailInputName = () =>
  `email-${Math.random().toString(36).slice(2, 10)}`;

const SignUpExample = () => {
  const [lastNameInputId] = useState(createLastNameInputId);
  const [emailInputName] = useState(createEmailInputName);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    username: '',
    password: '',
    confirmPassword: '',
    newsletter: false,
    terms: false,
  });
  const [message, setMessage] = useState('');

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!formData.terms) {
      setMessage('Please accept the terms and conditions.');
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setMessage('Password and confirm password do not match.');
      return;
    }

    setMessage(`Account created successfully for ${formData.firstName} ${formData.lastName}.`);
  };

  const handleClearPersonalDetails = () => {
    setFormData((prev) => ({
      ...prev,
      firstName: '',
      lastName: '',
      email: '',
      username: '',
    }));
    setMessage('');
  };

  const handleClearAccountDetails = () => {
    setFormData((prev) => ({
      ...prev,
      password: '',
      confirmPassword: '',
    }));
    setMessage('');
  };

  return (
    <div className="signup-page" id="signup-page">
      <div className="signup-header">
        <h2 className="signup-title" id="signup-title">
          Sign Up
        </h2>
        <p className="signup-subtitle" id="signup-subtitle">
          Practice following-sibling and preceding-sibling XPath on the action buttons below.
        </p>
      </div>

      <form className="signup-form" id="signup-form" onSubmit={handleSubmit}>
        <section className="signup-section personal-details" id="personal-details-section">
          <h3 className="signup-section-title">Personal Details</h3>

          <div className="form-row" id="name-row">
            <div className="form-field" id="first-name-field">
              <label id="first-name-label">First Name</label>
              <input
                type="text"
                className="signup-input signup-first-name"
                data-field="first-name"
                aria-label="First Name"
                title="First name field"
                autoComplete="given-name"
                value={formData.firstName}
                onChange={(event) =>
                  setFormData((prev) => ({ ...prev, firstName: event.target.value }))
                }
              />
            </div>

            <div className="form-field" id="last-name-field">
              <label id="last-name-label">Last Name</label>
              <input
                type="text"
                id={lastNameInputId}
                className="signup-input"
                value={formData.lastName}
                onChange={(event) =>
                  setFormData((prev) => ({ ...prev, lastName: event.target.value }))
                }
              />
            </div>
          </div>

          <div className="form-row" id="email-username-row">
            <div className="form-field" id="email-field">
              <label id="email-label">Email</label>
              <input
                type="email"
                name={emailInputName}
                className="signup-input"
                value={formData.email}
                onChange={(event) =>
                  setFormData((prev) => ({ ...prev, email: event.target.value }))
                }
              />
            </div>

            <div className="form-field" id="username-field">
              <label id="username-label">Username</label>
              <input
                type="text"
                value={formData.username}
                onChange={(event) =>
                  setFormData((prev) => ({ ...prev, username: event.target.value }))
                }
              />
            </div>
          </div>
        </section>

        <section className="signup-section account-details" id="account-details-section">
          <h3 className="signup-section-title">Account Details</h3>

          <div className="form-row" id="password-row">
            <div className="form-field" id="password-field">
              <label htmlFor="signup-password">Password</label>
              <input
                type="password"
                id="signup-password"
                name="password"
                className="signup-input"
                value={formData.password}
                onChange={handleChange}
              />
            </div>

            <div className="form-field" id="confirm-password-field">
              <label htmlFor="confirm-password">Confirm Password</label>
              <input
                type="password"
                id="confirm-password"
                name="confirmPassword"
                className="confirm-password-input"
                value={formData.confirmPassword}
                onChange={handleChange}
              />
            </div>
          </div>
        </section>

        <section className="signup-section preferences-section" id="preferences-section">
          <h3 className="signup-section-title">Preferences</h3>

          <div className="checkbox-group" id="preferences-group">
            <div className="checkbox-item newsletter-item" id="newsletter-label">
              <input
                type="checkbox"
                checked={formData.newsletter}
                onChange={(event) =>
                  setFormData((prev) => ({ ...prev, newsletter: event.target.checked }))
                }
              />
              <span id="newsletter">Subscribe to newsletter</span>
            </div>

            <label className="checkbox-item" id="terms-label">
              <input
                type="checkbox"
                id="terms"
                name="terms"
                checked={formData.terms}
                onChange={handleChange}
              />
              <span>I accept the terms and conditions</span>
            </label>
          </div>
        </section>

        <div className="form-actions" id="form-actions">
          <button
            type="button"
            className="signup-action-btn"
            id="clear-personal-details-btn"
            onClick={handleClearPersonalDetails}
          >
            Clear Personal Details
          </button>
          <button
            type="button"
            className="signup-action-btn"
            id="clear-account-details-btn"
            onClick={handleClearAccountDetails}
          >
            Clear Account Details
          </button>
          <button type="submit" className="signup-action-btn" id="signup-btn">
            Create Account
          </button>
        </div>
      </form>

      {message && (
        <p className="signup-message" id="signup-message">
          {message}
        </p>
      )}
    </div>
  );
};

export default SignUpExample;
